const data = {
  products: [
    {
      _id: "1",
      name: "Nike Air Max 270 to Chuck Taylors",
      description:
        "Nike's Air Force 1s were among the most popular sneakers this year.",
      image: "/images/shoe1.png",
      thumbnails: [
        "/images/shoe2.png",
        "/images/shoe3.png",
        "/images/shoe4.png"
      ],
      brand: "Nike",
      price: "$336.00",
      rating: "4.5",
      reviews: "60",
      colors: ["#f0969e", "#d5d5d4", "#1e1e1e", "#cb141a"],
      sizes: [41, 42, 43, 44, 45, 46, 47, 48],
      addToCart:false,
      
    },
    {
      _id: "2",
      name: "Nike Air Force 1",
      description:
        "Nike's Air Force 1s were among the most popular sneakers this year.",
      image: "/images/shoe2.png",
      thumbnails: [
        "/images/shoe1.png",
        "/images/shoe3.png",
        "/images/shoe4.png"
      ],
      brand: "Nike",
      price: "$300.00",
      rating: "3.5",
      reviews: "60",
      colors: ["#d5d5d4","#f0969e", "#1e1e1e", "#cb141a"],
      sizes: [41, 42, 43, 44,45,46,47,48],
      addToCart:false,
      
    },
    {
      _id: "3",
      name: "Nike Air Max 95",
      description:
        "Nike's Air Force 1s were among the most popular sneakers this year.",
      image: "/images/shoe3.png",
      thumbnails: [
        "/images/shoe1.png",
        "/images/shoe2.png",
        "/images/shoe4.png"
      ],
      brand: "Nike",
      price: "$400.00",
      rating: "4.5",
      reviews: "60",
      colors: ["#1e1e1e","#f0969e", "#d5d5d4", "#cb141a"],
      sizes: [41, 42, 43, 44,45],
      addToCart:false,
      
    },
    {
      _id: "4",
      name: "Nike Air Max 97",
      description:
        "Nike's Air Force 1s were among the most popular sneakers this year.",
      image: "/images/shoe4.png",
      thumbnails: [
        "/images/shoe1.png",
        "/images/shoe2.png",
        "/images/shoe3.png"
      ],
      brand: "Nike",
      price: "$500.00",
      rating: "4.5",
      reviews: "60",
      colors: [ "#cb141a","#f0969e", "#d5d5d4", "#1e1e1e"],
      sizes: [41, 42, 43, 44,45,47],
      addToCart:false,
      
    }
  ]
};

export default data;
